export type BaseError = {
    isError: true
    readonly message: string
}

export type HttpError = BaseError & {
    readonly payload: {
        error?: {
            message: string
            type: string
            code: number
            canBeIgnored?: boolean
        }
    }
}

export type APIError = BaseError & {
    error?: {
        message: string
        type: string
        code: number
        canBeIgnored?: boolean
    }
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadata : any
}

// This asserts to typescript that your object is or is not of type HttpError
// Prefer this instead of a boolean, it will assert it's type!
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isError(object: any): object is BaseError {
    // @ts-ignore
    return object != null && object.isError == true
}

export function newHttpError(message: string, payload: object): HttpError {
    return {
        isError: true,
        message: message,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/state/helpers/Error.ts